import React from "react";
import ReactApexChart from 'react-apexcharts';
import Utils from "../utils/utils";

export default class PieChart extends React.Component {
    constructor(props) {
        super(props);

        this.series = this.props.data.map(d => d.toFixed(2));
        this.fullSeries = this.props.data;
        let somma = 0;
        this.fullSeries.forEach(s => {
            somma += s;
        })

        let labels = this.props.labels;
        labels.forEach((label, index) => {
            let total = Utils.getNumberString(this.fullSeries[index].toFixed(2));
            let percent = ((this.fullSeries[index] / somma) * 100).toFixed(2) + " %";
            labels[index] = label + " (" + total + "€ - " + percent + ")";
        });
        
        this.options = {
            chart: {
                width: 0,
                type: 'pie',
            },
            labels: labels,
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        position: 'right'
                    }
                }
            }]
        };

        this.state = {
            width: undefined,
        }
    }

    componentDidUpdate() {

        if (this.props.width !== this.state.width || this.props.data !== this.fullSeries || this.props.labels !== this.options.labels) {
            this.setState({ width: this.props.width });

            let data = this.props.data.map(d => parseFloat(d.toFixed(2)));
            this.fullSeries = this.props.data;

            let somma = 0;
            this.fullSeries.forEach(s => {
                somma += s;
            })

            let labels = this.props.labels;
            labels.forEach((label, index) => {
                let total = Utils.getNumberString(this.fullSeries[index].toFixed(2));
                let percent = ((this.fullSeries[index] / somma) * 100).toFixed(2) + " %";
                labels[index] = label + " (" + total + "€ - " + percent + ")";
            });
            
            this.series = data;
            this.options = {
                chart: {
                    width: this.state.width,
                    type: 'pie',
                },
                labels: labels,
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'right'
                        }
                    }
                }]
            };
        }
    }

    render() {
        return(
            <ReactApexChart options={this.options} series={this.series} type="pie" width={this.state.width} />
        );
    }
}